import { Col, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { useConciergeContextState } from 'src/components/concierge/ConciergeContext';
import ExploreSection from 'src/components/project/explore/ExploreSection';
import MarketPriceByFormLineChart from 'src/components/analytics/MarketPriceByFormLineChart';
import PeriodSelect from 'src/components/form/PeriodSelect';
import { PreferredUnits } from 'src/utils/units';
import ExplorePanel from './ExplorePanel';

const EMPTY_OPTIONS = {};

export default function Pricing() {
  const [months, setMonths] = useState(6);
  const [filters = EMPTY_OPTIONS] = useConciergeContextState([
    'explore',
    'filters'
  ]);
  const [projectSettings] = useConciergeContextState([
    'explore',
    'projectSettings'
  ]);

  return (
    <ExploreSection
      title="Pricing"
      className="pricing-section"
      description="PCR prices for your material are compared against virgin prices to indicate whether discounts exist through Circular."
    >
      <Row gutter={16}>
        <Col span={24}>
          <ExplorePanel className="price-history-chart__panel" pad>
            <Typography.Title level={4} style={{ margin: '0 0 24px 0' }}>
              Pricing History
            </Typography.Title>
            <PeriodSelect value={months} onChange={(v) => setMonths(v)} />
            <Typography.Paragraph style={{ margin: '24px 0 0 0' }}>
              Material Price in Region ($/
              <PreferredUnits type="weight" />)
            </Typography.Paragraph>

            <MarketPriceByFormLineChart
              months={months}
              filters={filters}
              priceSettings={projectSettings?.prices}
            />
          </ExplorePanel>
        </Col>
      </Row>
    </ExploreSection>
  );
}
